import React from 'react';
import Table, { TableTitleDiv, TableStatDiv } from './Table';
import tableDataType from '../proptypes/table-data';
import TableBarChart from './TableBarChart';

const AttributesTable = ({ data }) => (
  <Table
    data={data}
    customCellRender={(cell, colTitle, cellIndex) => (
      <td key={`cell-${cellIndex}`} className={`cell-${cellIndex}`}>
        <TableTitleDiv>{colTitle}</TableTitleDiv>
        <TableStatDiv>
          <TableBarChart score={cell} />
        </TableStatDiv>
      </td>
    )}
  />
);

AttributesTable.propTypes = {
  data: tableDataType.isRequired,
};

export default AttributesTable;
